<div class="p-6.5">
    <div class="malou-text-18--bold flex justify-between pb-6.5">
        <span class="max-w-[80%]"> {{ 'maloupe.diagnostic_keywords.competitors_ranking.title' | translate }} "{{ keyword }}" </span>
        <mat-icon class="close cursor-pointer" [svgIcon]="SvgIcon.CROSS" (click)="cancel()"></mat-icon>
    </div>
    <div class="hide-scrollbar max-h-[400px] overflow-auto sm:!max-h-[380px]">
        @if (restaurantsRankingList.length) {
            @for (restaurantRanking of restaurantsRankingList; track restaurantRanking.placeId; let index = $index) {
                <a
                    class="border-malou-color-border-primary mb-1 flex items-center gap-x-4 rounded-xl border px-6.5 py-4.5"
                    href="https://search.google.com/local/reviews?placeid={{ restaurantRanking.placeId }}"
                    target="_blank"
                    [ngClass]="{ 'bg-malou-dark': restaurantIndex === index }">
                    <div class="rank" [style.color]="partnerTheme()?.header?.primaryColor ?? null">
                        {{ restaurantRanking.googlePosition }}
                    </div>
                    <div>
                        <div class="malou-text-12--bold">
                            {{ restaurantRanking.name }}
                        </div>
                        <div class="malou-text-12 text-malou-color-text-2 italic">
                            {{ restaurantRanking.address }}
                        </div>
                    </div>
                    @if (restaurantIndex === index) {
                        <div class="malou-text-10--semibold text-malou-color-text-1 grow text-end">
                            <span class="malou-text-14--regular">{{ getEmojiFromPosition(index + 1) }}</span>
                            {{ restaurantRanking.googlePosition | positionTranslate }}
                        </div>
                    }
                </a>
            }
        } @else {
            <div class="grid grow place-items-center p-5">
                <div class="flex flex-col items-center gap-y-3">
                    <img height="90" width="90" [src]="Illustration.GOGGLES | illustrationPathResolver" />
                    <div class="malou-text-14--bold">{{ 'maloupe.diagnostic_keywords.competitors_ranking.no_result' | translate }}</div>
                </div>
            </div>
        }
    </div>
</div>
